import PropTypes from "prop-types";
import React from "react";

import { Grid, makeStyles, useTheme } from "@material-ui/core";

/**
 * Layout component for vertical columns of SectionGridContainer components
 * Spaces section components evenly with no margin on top or bottom
 */

const useStyles = makeStyles((theme) => ({
  layout_column: {
    "& > * + *": {
      // direct children with adjacent siblings of first instance of section class
      marginTop: theme.spacing(2),
    },
  },
  layout_row: {
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

const SectionGridLayout = ({ children, direction, gridProps }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Grid
      container
      item
      direction={direction}
      justify="flex-start"
      alignItems="stretch"
      className={classes[`layout_${direction}`]}
      {...gridProps}
    >
      {children}
    </Grid>
  );
};

SectionGridLayout.propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.string,
  gridProps: PropTypes.object,
};

SectionGridLayout.defaultProps = {
  direction: "column",
  gridProps: {},
};

export default SectionGridLayout;
